export const WALLET_UPDATE_PENDING = 'WALLET_UPDATE_PENDING';
